import { render, staticRenderFns } from "./Species.vue?vue&type=template&id=919599cc&"
import script from "./Species.vue?vue&type=script&lang=js&"
export * from "./Species.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports